import TopBarProgress from "react-topbar-progress-indicator";

TopBarProgress.config({
    barColors: {
      "0": "#7860b6",
      "1.0": "#7860b6",
    },
    shadowBlur: 5,
  });
  